/**
 * Fired when something went wrong on the server side.
 *
 * @event error
 * @type {CartoError}
 * @api
 */

/**
 * Fired when a request to the server completed successfully.
 *
 * @event success
 * @api
 */

module.exports = {
  SUCCESS: 'success',
  ERROR: 'error'
};
